// Single source of truth for the NexCarat brand mark.
// The file lives in /public, so it's referenced by URL (honours PUBLIC_URL for sub-path deploys).
export const LOGO_URL = `${process.env.PUBLIC_URL || ''}/nexcarat-logo.png`;
